import _ from 'lodash';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormArray } from '@angular/forms';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { CampaignService } from '../../services/campaign.service';
import { select, Store } from '@ngrx/store';
import { loadEventList } from 'app/event/features/event.actions';
import { SharedService } from 'app/virtual-event/services/shared.service';
import { MDBSwitchService } from 'app/core/services/mdb-switch.service';
import { selectMerchandiseCampaignList } from 'app/campaign/features/campaign.selectors';

@Component({
  selector: 'app-campaign-merchandise-settings',
  templateUrl: './campaign-merchandise-settings.component.html',
  styleUrls: ['./campaign-merchandise-settings.component.scss']
})
export class CampaignMerchandiseSettingsComponent implements OnInit, OnDestroy {

  @Input() formGroupCampaignTypeData: UntypedFormGroup = null;

  private _campaignId: any = null;

  @Input()
  set campaignId(id: any) {
    this._campaignId = id;
  };
  get campaignId(): any {
    return this._campaignId;
  }

  public soldCount: number = 0;

  public merchandiseCampaigns$: any = this.store.pipe(
    select(selectMerchandiseCampaignList),
  );

  public isTolalInventoryValid = true

  public takeUntilSubject: Subject<any> = new Subject();

  constructor(
    public store: Store,
    public campaignService: CampaignService,
    public mdbSwitchService: MDBSwitchService,
    private sharedService: SharedService,
  ) {
    this.store.dispatch({
      type: loadEventList.type,
      payload: this.sharedService.token
    });
  }

  ngOnInit(): void {
    this.campaignService.configGroup(this.formGroupCampaignTypeData, this.formGroupCampaignTypeData,  'postActivityFormUrlRequired', [
      { name: 'postActivityFormUrl', defaultValue: "", validators: [Validators.required, Validators.pattern(/^(?:(?:http(s)?):\/\/(www\.)?)[-a-z0-9+&@#\/%?=~_|!:,.;]*[-a-z0-9+&@#\/%=~_|]$/i)] }
    ], this.takeUntilSubject);

    const sendTickets = this.formGroupCampaignTypeData.get('sendTickets') as UntypedFormControl;
    const enforceCampaignInventory = this.formGroupCampaignTypeData.get('enforceCampaignInventory') as UntypedFormControl;
    const campaignInventory = this.formGroupCampaignTypeData.get('campaignInventory') as UntypedFormControl;
    const hideCampaignInventory = this.formGroupCampaignTypeData.get('hideCampaignInventory') as UntypedFormControl;

    sendTickets.valueChanges.pipe(
      filter(value => !value),
      takeUntil(this.takeUntilSubject)
    ).subscribe(() => {
      const presetOptions = this.formGroupCampaignTypeData.get('presetOptions') as UntypedFormArray;
      for(let presetOption of presetOptions.controls) {
        const dontSendTickets = presetOption.get('dontSendTickets');
        dontSendTickets.setValue(false);
      }
    })

    enforceCampaignInventory.valueChanges.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((value) => {
      campaignInventory.clearValidators();
      campaignInventory.setValidators(value ? [Validators.min(1)]: []);
      campaignInventory.updateValueAndValidity();

      if(value === false) {
        campaignInventory.setValue(this.soldCount)
      }
      hideCampaignInventory.setValue(!value);
      hideCampaignInventory.updateValueAndValidity({ emitEvent: false });
    });

    campaignInventory.valueChanges.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe(value => {
      if(value < this.soldCount && enforceCampaignInventory.value){
        campaignInventory.setErrors({'incorrect': true});
        this.isTolalInventoryValid = false;
      } else{
        campaignInventory.setErrors(null);
        this.isTolalInventoryValid = true;
      }
    })

    this.merchandiseCampaigns$.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe(list => {
      const selectedCampaign = list.find(campaign => campaign.id === this.campaignId) || null;

      if(selectedCampaign) {
        const { presetOptions } = selectedCampaign.campaignTypeData;
        presetOptions.forEach(option => {
          if(!option.dontCountForGlobalInventory) {
            this.soldCount += option.bookedCount
          }
        })
      }
    })
  }

  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }

  getEventName(event, type = null): void {
    switch(event.type) {
      case 0:
        const { inPersonEventInfo } = event;
        return inPersonEventInfo.name;
      case 1:
        const { virtualEventInfo } = event;
        return virtualEventInfo.name;
      case 2:
        const { hybridEventInfo } = event;
        switch(type) {
          case 0:
            const { inPersonEvent } = hybridEventInfo;
            return inPersonEvent.name;
          case 1:
            const { virtualEvent } = hybridEventInfo;
            return virtualEvent.name;
        }
    }
    return null;
  }

  getSold(){
    const campaignInventory = this.formGroupCampaignTypeData.get('campaignInventory') as UntypedFormControl;
    const hideCampaignInventory = this.formGroupCampaignTypeData.get('hideCampaignInventory') as UntypedFormControl;
    
    if(hideCampaignInventory.value) {
      if(this.soldCount){
        return `${this.soldCount} Sold.` 
      } else{
        return 'None sold yet.'
      }
    } else {
      if(this.soldCount > 0){
        const soldText = campaignInventory.value > 0 ? `of ${campaignInventory.value} sold.` : ' of 0 sold.';
        return `${this.soldCount} ${soldText}`; 
      } else {
        const soldText = campaignInventory.value > 0 ? `0 of ${campaignInventory.value} sold.` : 'None sold yet.';
        return `${soldText}`; 
      }
    }
  }
}
